import React, {useMemo} from 'react';

import {useAction, useSelectorWithRefresh} from '@/store/kysely_module';
import {useCurrentWorkspaceId} from '@/store/modules/workspaces_module';
import {Comment} from './comment';
import {CommentForm} from './comment_form';

type Props = {
    parent_id: string;
    parent_type: 'File' | 'Project';
    clickedTimestamp: (timestamp: string) => void;
    onInitialFocus?: () => string;
    refreshComments: () => void;
    newTimestamp?: {timestamp: string} | null;
    variant: 'full' | 'compact';
};

export const useCommentActions = () => {
    return {
        addCommentToFile: useAction('addCommentToFile'),
        replyToComment: useAction('replyToComment'),
        deleteComment: useAction('deleteComment'),
        editComment: useAction('editComment'),
    };
};

export const CommentSection = (props: Props) => {
    const workspaceId = useCurrentWorkspaceId();

    const [originalComments, refreshComments] = useSelectorWithRefresh(
        'getCommentsAndRepliesForParent',
        {parent_id: props.parent_id, parent_type: props.parent_type},
        [],
        {workspace_id: workspaceId}
    );

    const comments = useMemo(() => [...originalComments].reverse(), [originalComments]);

    const actions = useCommentActions();

    const submitComment = async (text: string) => {
        await actions.addCommentToFile({comment_text: text, file_id: props.parent_id}, {workspace_id: workspaceId});
        refreshComments();
    };

    const replyToComment = async (text: string, parentId: string) => {
        await actions.replyToComment({text, parent_id: parentId}, {workspace_id: workspaceId});
        refreshComments();
    };

    const deleteComment = async (commentId: string) => {
        await actions.deleteComment({comment_id: commentId}, {workspace_id: workspaceId});
        refreshComments();
    };

    const editComment = async (commentId: string, text: string) => {
        await actions.editComment({comment_id: commentId, text}, {workspace_id: workspaceId});
        refreshComments();
    };

    return (
        <>
            {/* <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem'}}> */}
            <h3>Comments</h3>
            <CommentForm
                onSubmit={submitComment}
                onInitialFocus={props.onInitialFocus}
                newTimestamp={props.newTimestamp}
            />
            <div
                className='comment-list'
            >
                {comments?.map((c, i) => (
                    <Comment
                        key={c.id}
                        showUser={true}
                        variant={props.variant}
                        // showUser={(i === 0) || (comments[i].created_by !== c.created_by)}
                        comment={c}
                        clickedTimestamp={props.clickedTimestamp}
                        deleteComment={deleteComment}
                        editComment={editComment}
                        replyToComment={replyToComment}
                        onInitialFocus={props.onInitialFocus}
                    />
                ))}
            </div>

            {/* </div> */}
        </>
    );
};

export const parseTimestamps = (message: string): string[] => {
    return message.match(/([0-9]+:)?[0-9]+:[0-5][0-9]/g) || [];
}
